/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import {
  reactive,
} from 'vue';
import _forEach from 'lodash/forEach';
import AppConst from '../../constants/app.constant';
import {
  is_iphone,
} from '../../services/utils/is_iphone';
import utilityService from '../../services/utility.service';
import ConfigApplicationSettings from '../../config/application.config';
import ChartConst from '../../constants/chart.constant';
import d3 from '../../globalexports/d3.export';
// eslint-disable-next-line import/no-cycle
import httpService from '../../services/http.service';
// eslint-disable-next-line import/no-cycle
import router from '../../router';
import { routerPushInterface } from '../../services/router.interface';
import { getServiceHostPreference } from '../../services/utils/getServiceHostPreference';

function avwxService() {
  const content = reactive({});
  let avwxData;
  content.validationInfo = null;
  content.selectedTab = {};
  content.selectedSubtabGroup = {};
  content.selectedSubtab = {};
  content.cycleImageSubnavInterval = null;
  content.cycleImageAccordionInterval = null;
  content.cycleImageAccordionDelayRestart = null;
  content.getStepSpeed = (steps) => AppConst.fixedCycleTime / steps;
  content.formatDate = (value, showTimeZone) => {
    let dateFormat;
    let format;
    if (ConfigApplicationSettings.settings && ConfigApplicationSettings.settings.timeZone) {
      if (ConfigApplicationSettings.settings.timeZone === AppConst.timeZones.local.key) {
        format = ChartConst.timeFormat.local;
        format += ChartConst.dayFormat;
        if (showTimeZone && !is_iphone()) {
          format += ` ${utilityService.getTimeZoneShort()}`;
        }
        dateFormat = d3.timeFormat(format);
      } else {
        format = ChartConst.timeFormat.zulu;
        format += ChartConst.dayFormat;
        dateFormat = d3.utcFormat(format);
      }
      return dateFormat(value);
    }
    return '';
  };
  content.getImageryValidInfo = function (data) {
    if (data) {
      return `Valid ${content.formatDate(data, true)}`;
      // switch (data.length) {
      //   case 1:
      //     return `Valid ${content.formatDate(data, true)}`;
      //   case 2:
      //     return `Valid ${content.formatDate(data[0], false)} to
      // ${content.formatDate(data[1], true)}`;
      //   default:
      // }
    }
    return '';
  };
  content.getAvwxData = async () => {
    if (avwxData) {
      return avwxData;
    }
    const data = await content.getAvwxDataFromJson();
    return data;
  };
  content.preSelectSubtabFromBookmark = (pathObj, getPreselectedSubtab, avwxDataObj) => {
    if (!avwxData && avwxDataObj) {
      avwxData = avwxDataObj;
    }
    let preSelectedTab;
    let preSelectedSubtabGroup;
    let preSelectedSubtab;
    const slideIndexes = [];
    _forEach(avwxData, (tab) => {
      if (tab.t === pathObj[0].t || tab.p === pathObj[0].t) {
        preSelectedTab = tab;
      }
    });
    if (preSelectedTab && preSelectedTab.c && pathObj[1]) {
      _forEach(preSelectedTab.c, (tab) => {
        if (tab.t === pathObj[1].t || tab.p === pathObj[1].t) {
          preSelectedSubtabGroup = tab;
        }
      });
    }
    if (!preSelectedSubtabGroup && pathObj.length === 3) {
      preSelectedSubtabGroup = preSelectedTab;
    }
    if (preSelectedSubtabGroup && preSelectedSubtabGroup.c && pathObj[2]) {
      _forEach(preSelectedSubtabGroup.c, (tab) => {
        if (tab.t === pathObj[2].t || tab.p === pathObj[2].t) {
          preSelectedSubtab = tab;
        }
      });
    }
    if (getPreselectedSubtab) {
      switch (pathObj.length) {
        case 3:
          return preSelectedSubtab;
        case 2:
          return preSelectedSubtabGroup;
        case 1:
          return preSelectedTab;
        default:
      }
    }
    switch (pathObj.length) {
      case 3:
        content.setSelectedTab(preSelectedTab);
        content.setSelectedSubtabGroup(preSelectedSubtabGroup);
        content.setSelectedSubtab(preSelectedSubtab);
        if (preSelectedSubtabGroup === preSelectedTab) {
          slideIndexes.push(0);
          slideIndexes.push(2);
        } else {
          slideIndexes.push(0);
          slideIndexes.push(1);
          slideIndexes.push(2);
        }
        break;
      case 2:
        content.setSelectedTab(preSelectedTab);
        content.setSelectedSubtab(preSelectedSubtabGroup);
        slideIndexes.push(0);
        slideIndexes.push(2);
        break;
      case 1:
        content.setSelectedTab(preSelectedTab);
        content.setSelectedSubtab(preSelectedTab);
        slideIndexes.push(0);
        break;
      default:
    }
    return slideIndexes;
  };
  content.initView = async () => {
    const pathObj = content.getPathKeyValue();
    const data = await content.getAvwxData();
    const response = {
      avwxData: data,
      pathObj,
    };
    if (pathObj && pathObj.length) {
      response.slidesIndexes = content.preSelectSubtabFromBookmark(pathObj);
    }
    return response;
  };
  content.getPathKeyValue = () => {
    let pathKeyString = router.currentRoute.value.query.pathkey2;
    let isPathValid = true;
    if (!pathKeyString) {
      pathKeyString = router.currentRoute.value.query.pathkey;
    }
    let pathKeyObj = null;
    if (pathKeyString) {
      try {
        pathKeyObj = JSON.parse(pathKeyString);
      } catch (ex) {
        pathKeyObj = null;
      }
    }
    if (pathKeyObj) {
      _forEach(pathKeyObj, (tab) => {
        if (!tab.t) {
          isPathValid = false;
        }
      });
    }
    if (isPathValid === false) {
      pathKeyObj = null;
    }
    return pathKeyObj;
  };
  content.setPathKey = () => {
    const obj = {
      pathkey: content.getPathKeyFromData(true),
      pathkey2: content.getPathKeyFromData(),
      subtab: content.selectedSubtab.p,
    };
    const queryParam = {
      pathkey: obj.pathkey2 || obj.pathkey,
    };
    routerPushInterface({
      query: queryParam,
    });
    return obj;
  };
  content.getPathKeyFromData = (placeholder) => {
    const pathkey = [];
    if (content.selectedTab) {
      pathkey.push({
        t: placeholder
          ? (content.selectedTab.p || content.selectedTab.t)
          : content.selectedTab.t,
      });
    }
    if (content.selectedTab && !content.selectedTab.i && content.selectedSubtabGroup && content
      .selectedSubtabGroup.c) {
      pathkey.push({
        t: placeholder
          ? (content.selectedSubtabGroup.p || content.selectedSubtabGroup.t)
          : content.selectedSubtabGroup.t,
      });
    }
    if (content.selectedTab && !content.selectedTab.i && content.selectedSubtab && content
      .selectedSubtab.t) {
      pathkey.push({
        t: placeholder
          ? (content.selectedSubtab.p || content.selectedSubtab.t)
          : content.selectedSubtab.t,
      });
    }
    return JSON.stringify(pathkey);
  };
  content.setSelectedSubtabGroup = (subtabGroup) => {
    content.selectedSubtabGroup = subtabGroup;
  };
  content.setSelectedTab = (tab) => {
    content.selectedTab = tab;
  };
  content.setSelectedSubtab = (tab) => {
    content.selectedSubtab = tab;
  };
  content.getAvwxDataFromJson = async () => {
    avwxData = await httpService.http_get(AppConst.imageryDataSource);
    return avwxData;
  };
  content.returnImageSizeRef = (src) => new Promise((resolve) => {
    const imgTemp = new Image();
    const refData = {
      naturalHeight: 0,
      naturalWidth: 0,
    };
    imgTemp.onload = () => {
      refData.naturalHeight = imgTemp.naturalHeight;
      refData.naturalWidth = imgTemp.naturalWidth;
      resolve(refData);
    };
    imgTemp.onerror = () => {
      resolve(refData);
    };
    imgTemp.src = src;
  });
  return content;
}
export default avwxService();
